<template>
<div>
    <div class="columns">
        <b-field label="Title" class="column is-half">
            <b-input v-model="university.title" required type="text" name="title"></b-input>
        </b-field>

        <b-field label="Image URL" class="column is-half">
            <b-input v-model="university.img_url" type="text" name="img_url"></b-input>
        </b-field>

        <b-field label="Google docs URL" class="column is-half">
            <b-input v-model="university.docs_url" type="text" name="docs_url"></b-input>
        </b-field>

        <b-field label="Address" class="column is-half">
            <b-input v-model="university.address" type="text" name="address"></b-input>
        </b-field>

        <div class="column is-full">
          <b-button :disabled="isSubmitDisabled" @click="saveUniversity" type="is-primary" class="submit-btn">Submit</b-button>
          <b-button class="btn" @click="$router.go(-1)" style="margin-left: 15px;">Go back</b-button>
        </div>

        <b-image v-if="university.img_url" :src="university.img_url" alt="University logo" class="column is-full uni-image"></b-image>
    </div>
</div>
</template>

<script>
import UniversityService from "../../services/university.service";

export default {
    name: "add-university",
    data() {
        return {
            university: {
                id: null,
                title: "",
                img_url: "",
                docs_url: '',
                address: ""
            },
        };
    },
    computed: {
        isSubmitDisabled() {
            return !this.university.title
        }
    },
    mounted() {
        this.checkUrl()
    },
    methods: {
        checkUrl() {
            const currentUrl = window.location.pathname.split('/')[2];

            if (Number.isInteger(+currentUrl)) {
                UniversityService.get(currentUrl)
                    .then(response => {
                        this.university = response.data;
                    })
            }
        },
        saveUniversity() {
            if (this.university.id) {
                UniversityService.update(this.university.id, this.university).then(() => {
                    this.$buefy.toast.open({
                            duration: 3000,
                            message: `University updated succesfully`,
                            position: 'is-bottom',
                            type: 'is-success'
                        })
                })
            } else {
                UniversityService.create(this.university)
                    .then(response => {
                        this.university.id = response.data.id;
                        this.$buefy.toast.open({
                            duration: 3000,
                            message: `University created succesfully`,
                            position: 'is-bottom',
                            type: 'is-success'
                        })
                    })
            }

        },

        newUniversity() {
            this.submitted = false;
            this.university = {
                id: null,
                title: "",
                img_url: "",
                docs_url: "",
                address: ""
            }
        },

        goBack() {
            this.$router.go(-1)
        }
    }
};
</script>

<style>
.submit-btn {
    margin: 0 auto;
    display: block;
}

.columns {
    flex-wrap: wrap;
}

.uni-image {
  max-width: 200px;
}
</style>
